import React, { useState } from "react";
import { 
  Avatar, 
  Menu, 
  MenuItem, 
  IconButton, 
  Tooltip, 
  Divider,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import { 
  AccountCircle as ProfileIcon,
  Settings as SettingsIcon,
  Logout as LogoutIcon,
  Notifications as NotificationsIcon
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../contexts/LoadingContext";
import { logout } from "../../Common/SharedApis/Auth";

const HeaderNav = () => {
  const navigate = useNavigate();
  const { isLoading, setIsLoading } = useLoading();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [notificationsAnchor, setNotificationsAnchor] = useState<null | HTMLElement>(null);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNotificationsOpen = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationsAnchor(event.currentTarget);
  };

  const handleNotificationsClose = () => {
    setNotificationsAnchor(null);
  };

  const handleLogout = () => {
    setIsLoading(true);
    logout();
    setIsLoading(false);
    navigate('/login');
    handleProfileMenuClose();
  };

  const handleProfile = () => {
    navigate("/profile");
    handleProfileMenuClose();
  };

  const handleSettings = () => {
    // Navigate to settings or open settings modal
    handleProfileMenuClose();
  };

  const open = Boolean(anchorEl);
  const notificationsOpen = Boolean(notificationsAnchor);

  return (
    <div className="header-nav">
      {/* Notifications */}
      <Tooltip title="Notifications">
        <IconButton
          onClick={handleNotificationsOpen}
          className="header-nav-btn"
          size="large"
        >
          <NotificationsIcon />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={notificationsAnchor}
        open={notificationsOpen}
        onClose={handleNotificationsClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        PaperProps={{
          className: 'header-menu',
          elevation: 8,
        }}
      >
        <MenuItem onClick={handleNotificationsClose}>
          <ListItemText 
            primary="No new notifications" 
            secondary="You're all caught up!"
          />
        </MenuItem>
      </Menu>

      {/* Profile Menu */}
      <Tooltip title="Account settings">
        <IconButton
          onClick={handleProfileMenuOpen}
          className="header-nav-btn profile-btn"
          size="large"
        >
          <Avatar 
            className="header-avatar"
            src="https://i.pravatar.cc/150?img=3"
            alt="User Avatar"
          />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleProfileMenuClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        PaperProps={{
          className: 'header-menu',
          elevation: 8,
        }}
      >
        <MenuItem onClick={handleProfile}>
          <ListItemIcon>
            <ProfileIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Profile</ListItemText>
        </MenuItem>
        
        <MenuItem onClick={handleSettings}>
          <ListItemIcon>
            <SettingsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Settings</ListItemText>
        </MenuItem>
        
        <Divider />
        
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default HeaderNav;
